import { render, staticRenderFns } from "./TopicSample.vue?vue&type=template&id=088289ba&scoped=true&"
import script from "./TopicSample.vue?vue&type=script&lang=js&"
export * from "./TopicSample.vue?vue&type=script&lang=js&"
import style0 from "./TopicSample.vue?vue&type=style&index=0&id=088289ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "088289ba",
  null
  
)

export default component.exports